
import {createSlice, createSelector} from '@reduxjs/toolkit';
import {FormNoticeInit} from "./model";


// import {INIT} from './../constants/status';

const initialState = {
    notices: [],
    noticeForm: FormNoticeInit,
};

const noticeSlice = createSlice({
    name: 'notice',
    initialState,
    reducers: {
        setNotices: (state, action) => {
            state.notices = action.payload;
        },
        onNoticeFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.noticeForm[name] = value;
        },
        initNoticeForm: (state, action) => {
            state.noticeForm = action.payload;
        },
    },
});

export const {actions} = noticeSlice;
export const {
    setNotices,
    onNoticeFormChange,
    initNoticeForm,
} = actions;

// selectors

export const selNotices = (state) => state.notice.notices;
export const selNoticeForm = (state) => state.notice.noticeForm;

const reducer = {
    notice: noticeSlice.reducer,
};
export default reducer;